import { FC, useCallback, useState } from 'react';
import { Merge } from 'type-fest';
import { ActionModal } from '~/components/elements/ActionModal/ActionModal';
import { MessageModal } from '~/components/elements/MessageModal/MessageModal';

type ActionModalProps = Parameters<typeof ActionModal>[0];

type UseActionModalResult = {
  Modal: FC<Merge<ActionModalProps, { onClose?: ActionModalProps['onClose'] }>>;
  openModal: () => void;
  closeModal: () => void;
};

export function useActionModal(): UseActionModalResult {
  const [isOpened, setOpened] = useState(false);

  const openModal = useCallback(() => {
    setOpened(true);
  }, []);
  const closeModal = useCallback(() => {
    setOpened(false);
  }, []);

  const Modal: UseActionModalResult['Modal'] = useCallback(
    (props) => {
      return isOpened ? (
        <ActionModal
          {...props}
          onClose={() => {
            props.onClose?.();
            closeModal();
          }}
        />
      ) : null;
    },
    [isOpened, closeModal],
  );

  return { Modal, openModal, closeModal };
}

type MessageModalProps = Parameters<typeof MessageModal>[0];

type UseMessageModalResult = {
  Modal: FC<Merge<MessageModalProps, { onClose?: ActionModalProps['onClose'] }>>;
  openModal: () => void;
  closeModal: () => void;
};

export function useMessageModal(): UseMessageModalResult {
  const [isOpened, setOpened] = useState(false);

  const openModal = useCallback(() => {
    setOpened(true);
  }, []);
  const closeModal = useCallback(() => {
    setOpened(false);
  }, []);

  const Modal: UseMessageModalResult['Modal'] = useCallback(
    (props) => {
      return isOpened ? (
        <MessageModal
          {...props}
          onClose={() => {
            props.onClose?.();
            closeModal();
          }}
        />
      ) : null;
    },
    [isOpened, closeModal],
  );

  return { Modal, openModal, closeModal };
}
